import React from 'react';

export const SHHeader = () => (
  <div className="flex flex-row w-[100%] my-2 text-center text-[#9E9E9E] text-base text-[1vw]">
    <div className="w-[8%] ">TO</div>
    <div className="w-[7%] ">MANAGER</div>
    <div className="w-[22%] ">ORDER</div>
    <div className="w-[5%] ">SO</div>
    <div className="w-[5%] ">SH</div>
    <div className="w-[5%] ">IMG</div>
    <div className="w-[5%] ">COL</div>
    <div className="w-[33%] "></div>
    <div className="w-[10%] ">FINISH</div>
  </div>
); 